import { render, staticRenderFns } from "./ButtonPresave.vue?vue&type=template&id=1f78f1b8&scoped=true"
import script from "./ButtonPresave.vue?vue&type=script&lang=js"
export * from "./ButtonPresave.vue?vue&type=script&lang=js"
import style0 from "./ButtonPresave.vue?vue&type=style&index=0&id=1f78f1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f78f1b8",
  null
  
)

export default component.exports